import { ChildDiscountConfig, Trip } from "@/types";
import { getTripById, updateTrip } from "./tripService";

/**
 * Service for managing child discount configuration.
 * Provides a dedicated interface for child discount operations while internally
 * using the trip service for persistence, maintaining modularity and separation of concerns.
 */
export const childDiscountService = {
  /**
   * Updates the child discount configuration for a trip.
   * @param tripId The ID of the trip to update
   * @param config The new child discount configuration
   */
  updateChildDiscountConfig: async (tripId: string, config: ChildDiscountConfig): Promise<void> => {
    const trip = await getTripById(tripId);
    if (!trip) {
      throw new Error("Trip not found");
    }
    
    await updateTrip({ ...trip, childDiscountConfig: config });
  }
};
